/* @refresh reload */
import { render } from 'solid-js/web'

import './index.css'
import App from './App'

import { genPatches } from './generate-patch';

if (window.location.search.includes('spice2x')) {
  genPatches();
} else {
  const root = document.getElementById('root')
  render(() => <App />, root!)
}
